<template>
	<v-container class="pa-0">
		<v-row class="px-3 pb-2">
			<v-col
				cols="12"
				md="12" class="pa-0">
				<v-card color="#333" width="1450px" :height="WindowSize.y - 150" class="mx-auto" rounded="0" flat>
					<div class="qr-message" :class="{suc: this.result !== ''}"><span v-if="this.result !== ''">{{ $t('text.regManFound') }} ({{athlet}})</span></div>
					<div class="qrwrap mb-2"><qrcode-stream @decode="onDecode" @init="onInit"/></div>
					<v-row><v-col cols="12" sm="4" class="py-0">
							<c-button
								:disabled="loading || this.result === ''"
								@click="scan"
								:label="$t(`text.accept`)"
								:type="this.result === '' ? 'button' : 'important'"
								class="w-100">
							</c-button>
							</v-col><v-col cols="12" sm="4" class="py-0">
							<c-button
								:disabled="loading || this.result === ''"
								@click="scanAndNext"
								:label="$t(`text.createAndScan`)"
								:type="this.result === '' ? 'button' : 'important'"
								class="w-100">
							</c-button>
							</v-col>
							<v-col cols="12" sm="4" class="py-0">
							<c-button
								:disabled="loading"
								@click="back"
								:label="$t(`text.abortUC`)"
								class="w-100">
							</c-button>
						</v-col></v-row>
				</v-card>
				<spinner :loading="loading"></spinner>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

import { QrcodeStream } from 'vue-qrcode-reader';
import digiRegmanActions from '../store/actions/digiRegman';
import namespace from '../store/namespace';

import Spinner from '../general/Spinner.vue';

import CButton from '../globalComponents/CButton.vue';


import modelState from '../mixins/modelState';

export default {
	name: 'Competitions',
	mixins: [modelState],
	components: {
		QrcodeStream,
		Spinner,
		CButton,
	},
	async mounted() {
		if (this.Links.length === 0) await this.GET_DIGI_REG_LINKS();
	},
	data() {
		return {
			loading: true,
			error: '',
			result: '',
			athlet: this.$t('text.checking'),
		};
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.DIGIREGMAN, ['Links']),
	},
	methods: {
		...mapActions(namespace.DIGIREGMAN, [
			digiRegmanActions.GET_DIGI_REG_LINKS,
			digiRegmanActions.GET_DIGI_REGMAN_INFO,
			digiRegmanActions.ADD_COMPETITOR]),
		async onDecode(result) {
			try {
				this.result = '';
				this.athlet = this.$t('text.checking');
				setTimeout(() => {
					this.result = result;
				}, 1000);

				const sp = result.split('/');
				const data = await this.GET_DIGI_REGMAN_INFO(sp[sp.length - 1]);
				if (data) {
					this.athlet = `${data.competitorName} - ${data.competition_Name} | ${data.competitionLocationName} - ${this.$moment(data.competition_Date).format('DD.MM.YYYY')}`;
				}
			} catch (ex) {
				this.athlet = this.$t('text.errorBadQR');
			}
		},
		async onInit(promise) {
			try {
				await promise;
			} catch (error) {
				if (error.name === 'NotAllowedError') {
					this.error = 'ERROR: you need to grant camera access permisson';
				} else if (error.name === 'NotFoundError') {
					this.error = 'ERROR: no camera on this device';
				} else if (error.name === 'NotSupportedError') {
					this.error = 'ERROR: secure context required (HTTPS, localhost)';
				} else if (error.name === 'NotReadableError') {
					this.error = 'ERROR: is the camera already in use?';
				} else if (error.name === 'OverconstrainedError') {
					this.error = 'ERROR: installed cameras are not suitable';
				} else if (error.name === 'StreamApiNotSupportedError') {
					this.error = 'ERROR: Stream API is not supported in this browser';
				}
			}
			this.loading = false;
		},
		scan() {
			const sp = this.result.split('/');
			if (sp.length != 0) {
				this.$router.push({ name: 'competitions', params: { cId: sp[sp.length - 1] } });
			}
		},
		async scanAndNext() {
			const sp = this.result.split('/');
			if (sp.length != 0) {
				await this.ADD_COMPETITOR(sp[sp.length - 1]);
			}
			this.result = '';
		},
		back() {
			this.$router.go(-1);
		},
	},
};
</script>

<style lang="scss" scoped>

@import "../globalComponents/style/_globals";

.qr-message {
	text-align: center;
    line-height: 30px;
    color: #fff;
}

.suc {
	background-color:$toast-bg;
	animation: blink 0.5s linear;
}

.qrwrap {
	max-height: 80%;
	overflow: hidden;
}


@keyframes blink {
	0% { background-color: $toast-bg; }
	100% { background-color: $prim_aleart_light_color; }
}
</style>
